import React, { useEffect } from 'react';

import './Hero.css';
import logo from './../images/bookie-logo.svg';
import hero from './../images/bookie-hero.svg';
import hero500 from './../images/hero/bookie-hero-p-500.png';
import hero800 from './../images/hero/bookie-hero-p-800.png';
import hero1080 from './../images/hero/bookie-hero-p-1080.png';
import heroDefault from './../images/hero/bookie-hero.png';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import { useTranslation } from '../i18n';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const Hero = ({ theme, handleThemeChange }) => {
  const { t, changeLanguage } = useTranslation();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const lang = urlParams.get('lang');

    if (lang === 'sv' || lang === 'en') {
      changeLanguage(lang);
    }
  }, []);

  return (
    <main className="hero-wrapper">
      <section className="bookie-hero">
        <div className="blockcontainer">
          <div className="bookie-hero-copy">
            <div key="wrapper" className="logo-wrapper">
              <img src={logo} alt="Bookie logo" width={200} height={65} />
              <h1>{t.tagline}</h1>
            </div>
            <div className="bookie-button-wrapper">
              <a
                href="#how-it-works"
                className="btn btn-primary"
                onClick={() => {
                  logEvent(analytics, 'hero_button_clicked', {
                    button_name: 'Learn more',
                  });
                }}
              >
                {t.hero.cta}
              </a>
              <Link
                to="/login"
                className="btn btn-secondary"
                onClick={() => {
                  logEvent(analytics, 'hero_button_clicked', {
                    button_name: 'Login 1',
                  });
                }}
              >
                {t.hero.login}
              </Link>
            </div>
          </div>
          <div className="div-block centered">
            <img
              src={hero}
              alt="Bookie app shown in three mobile devices"
              className="bookie-responsive-img"
              loading="lazy"
              sizes="(max-width: 767px) 96vw, (max-width: 991px) 728px, 940px"
              srcSet={`${hero500} 500w, ${hero800} 800w, ${hero1080} 1080w, ${heroDefault} 1280w`}
            />
          </div>
        </div>
      </section>
      <div className="section-work">
        <div className="blockcontainer">
          <h3 className="bookie-subheader">{t.hero.subheader}</h3>
          <div className="scroll-animate">
            <p className="bookie-text">{t.hero.introtext}</p>
          </div>
          <div id="how-it-works" className="bookie-step first scroll-animate">
            <div className="bookie-step-column">
              <h2 className="bookie-step-title">{t.hero.howitworks}</h2>
              <h3 className="bookie-step-header">{t.hero.step1}</h3>
              <p className="bookie-step-text">{t.hero.step1text}</p>
            </div>
            <div className="bookie-image-column"></div>
          </div>
          <div className="bookie-step second scroll-animate">
            <div className="bookie-image-column second"></div>
            <div className="bookie-step-column">
              <h2 className="bookie-step-title">{t.hero.howitworks}</h2>
              <h3 className="bookie-step-header">{t.hero.step2}</h3>
              <p className="bookie-step-text">{t.hero.step2text}</p>
            </div>
          </div>
          <div className="bookie-step third scroll-animate">
            <div className="bookie-step-column">
              <h2 className="bookie-step-title">{t.hero.howitworks}</h2>
              <h3 className="bookie-step-header">{t.hero.step3}</h3>
              <p className="bookie-step-text">{t.hero.step3text}</p>
            </div>
            <div className="bookie-image-column third"></div>
          </div>
          <div className="scroll-animate">
            <h3 className="bookie-subheader">{t.hero.why}</h3>
            <p className="bookie-text">{t.hero.whytext}</p>
            <div className="flex-centered">
              <Link
                to="/login"
                className="btn btn-primary"
                onClick={() => {
                  logEvent(analytics, 'hero_button_clicked', {
                    button_name: 'Login 2',
                  });
                }}
              >
                {t.hero.cta2}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <section className="section-work purple">
        <div className="blockcontainer scroll-animate">
          <h3 className="bookie-subheader">{t.hero.didyouknow}</h3>
          <ul className="bookie-list" role="list">
            <li className="bookie-list-item">{t.hero.didyouknowbullet1}</li>
            <li className="bookie-list-item bookie-last-item">
              {t.hero.didyouknowbullet2}
            </li>
          </ul>
        </div>
      </section>
      <section className="bookie-footer">
        <div className="blockcontainer bookie-footer">
          <Footer
            key="footer"
            theme={theme}
            handleThemeChange={handleThemeChange}
          />
        </div>
      </section>
    </main>
  );
};

export default Hero;
